const AUDIT_LOG_CONFIG_STORAGE_KEY = "auditLogConfig";

export const isTrackingBlocked = () => {
  try {
    const cached = localStorage.getItem(AUDIT_LOG_CONFIG_STORAGE_KEY);
    if (!cached) {
      return false;
    }

    const { value } = JSON.parse(cached);
    const isLogEnabled = value?.isLogEnabled ?? value?.IsLogEnabled;
    return Number(isLogEnabled) !== 1;
  } catch (error) {
    console.warn("Reading cached auditLogConfig failed. Tracking remains enabled:", error);
    return false;
  }
};

